import type { StudentLeaderboardRoutes } from 'ulanano-cms-api/routes/student-leaderboard'
import { createGranularTreaty } from '../api-factory'

export const studentLeaderboardApi = createGranularTreaty<StudentLeaderboardRoutes>({ withCookies: true })
